//
// forms/api.js
//
// - NB: Marketo does not seem to do any form verification server side.
//

import { post } from "nayjax";

const endpoint = "/wp-json/mkto/submit-lead"; // 'https://app-lon04.marketo.com/index.php/leadCapture/save2';
const munchkinId = "461-RKK-518";

const buffs_endpoint =
  "https://qyek9r2crj.execute-api.us-east-1.amazonaws.com/Prod/submit";

// submit() - dispatch to marketo
// ---------------------------------

function submit(data) {
  Object.keys(data).forEach((k) => {
    console.log(k, data[k]);
  });
  data.munchkinId = munchkinId;
  console.log("submit:", data);
  return post(endpoint, data);
}

// submit__buffs - dispatch to BUFFS
// ---------------------------------

function submit__buffs(data) {
  console.log("submit__buffs:", data);
  return post(buffs_endpoint, JSON.stringify(data));
}

// submit__local - dispatch to wp-json
// -----------------------------------

function submit__local(endpoint, data) {
  console.log("submit__local:", data);

  // nayjax does not support setting headers
  return fetch(`${window.api_url}${endpoint}`, {
    method: "POST",
    headers: new Headers({
      "X-WP-Nonce": window.nonce,
    }),
    body: JSON.stringify(data),
  }).then((response) => response.json());
}

export { submit, submit__buffs, submit__local };
